import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 7l8 10m-8 0l8 -10","key":"svg-0"}],["path",{"d":"M21 20h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2","key":"svg-1"}]]

/**
 * IconSubscript
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc3Vic2NyaXB0Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik01IDdsOCAxMG0tOCAwbDggLTEwIiAvPgogIDxwYXRoIGQ9Ik0yMSAyMGgtNGwzLjUgLTRhMS43MyAxLjczIDAgMCAwIC0zLjUgLTIiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/subscript
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconSubscript = createReactComponent('outline', 'subscript', 'Subscript', __iconNode);

export default IconSubscript;